import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import {app} from '../main'

import uz from './langMessages/uz.json';
import uz_latn from './langMessages/uz-latn.json';
import ru from './langMessages/ru.json';
// import md from './langMessages/md.json';

Vue.use(VueI18n);

const locale = localStorage.getItem('locale') || 'ru';

const messages = {
	uz: uz,
	'uz-latn': uz_latn,
	ru: ru,
	// md: md,
};

const i18n = new VueI18n({
	locale,
	messages
});

export default i18n;

/*export default async ({store}) => {
	if (process.client) {
		await loadMessages(store.getters['locales/locale'])
	}
	app.i18n = i18n;
};*/

/*export async function loadMessages (locale) {
	if (Object.keys(i18n.getLocaleMessage(locale)).length === 0) {
		const messages = await import(`./langMessages/${locale}`);
		i18n.setLocaleMessage(locale, messages)
	}

	if (i18n.locale !== locale) {
		i18n.locale = locale
	}
}*/
